import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";

const exploreLinks = [
  { label: "头条解读", id: "headline" },
  { label: "重点瓜分析", id: "analysis" },
  { label: "深度报道", id: "deep" },
  { label: "封面故事", id: "cover" },
  { label: "编辑推荐", id: "pick" },
];

export default function Footer() {
  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-secondary-50 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* 品牌 */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-goblet-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-serif text-xl font-black text-foreground-950">今日瓜报</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              不止吃瓜，更看懂门道。今日瓜报专注娱乐热点头条解读、重点瓜分析与深度报道，用客观的视角还原事件来龙去脉，陪伴每一位追求深度的读者。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-qq-fill", "ri-douban-fill", "ri-rss-fill"].map((ic, idx) => (
                <a
                  key={idx}
                  href="#subscribe"
                  onClick={(e) => e.preventDefault()}
                  aria-label="关注今日瓜报社交账号"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* 栏目 */}
          <div className="lg:col-span-2">
            <h3 className="font-serif text-base font-bold text-foreground-950">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {exploreLinks.map((l) => (
                <li key={l.id}>
                  <Link
                    to={`/#${l.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-700 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 站内 */}
          <div className="lg:col-span-2">
            <h3 className="font-serif text-base font-bold text-foreground-950">站内速览</h3>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/#about" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">关于我们</Link></li>
              <li><Link to="/#about" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">内容原则</Link></li>
              <li><Link to="/#faq" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">常见问题</Link></li>
              <li><Link to="/#contact" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">联系编辑部</Link></li>
              <li><Link to="/#feed" className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">全部内容</Link></li>
            </ul>
          </div>

          {/* 订阅 */}
          <div className="lg:col-span-4">
            <h3 className="font-serif text-base font-bold text-foreground-950">每日瓜报订阅</h3>
            <p className="mt-2 text-sm text-foreground-600">第一时间接收今日头条解读与重点瓜分析摘要，零打扰、可随时退订。</p>
            <div className="mt-4">
              <NewsletterForm />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 今日瓜报 · 深度娱乐资讯媒体 · 保留所有权利</p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <a href="#subscribe" onClick={(e) => e.preventDefault()} className="hover:text-primary-700 transition-colors">隐私政策</a>
            <a href="#subscribe" onClick={(e) => e.preventDefault()} className="hover:text-primary-700 transition-colors">免责声明</a>
            <a href="#subscribe" onClick={(e) => e.preventDefault()} className="hover:text-primary-700 transition-colors">投稿与合作</a>
            <button onClick={goTop} className="flex items-center gap-1 text-foreground-600 hover:text-primary-700 transition-colors">
              返回顶部 <i className="ri-arrow-up-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}